export const BASIC_ROTATION = - Math.PI * 0.5;